<template>
  <v-app class="customNotification">
    <notifications
    position="top right"
    group="all"
    :duration="2000"
  />
    <transition-group v-if="$store.state.window >= 1100" name="">
      <welcome-menu @close="reverseDialog(3)" v-if="dialogs[3].value" key="0"/>
      <div :class="[this.$lang === 'ar' ? 'left-side' : 'right-side', 'triangle border-white-1-50']" v-if="dialogs[3].value" key="1"></div>
    </transition-group>
<!--    <transition v-if="$store.state.window >= 1100" name="slide-fade">-->
<!--    </transition>-->
    <v-main>
      <sidebar/>
      <router-view/>
      <div class="yellow-button flex-center needHelp no-scale" v-on:click="reverseDialog(2)">
        <div class="white-blur"></div>
        <transition name="fade" mode="out-in">
          <span v-if="!dialogs[2].value">{{$t('needHelp')}}</span>
          <img class="d-inline-block" v-if="dialogs[2].value" src="../src/assets/icons/closeSupport.svg">
        </transition>
      </div>
      <div class="black-blur blur-help"></div>
      <transition name="slide-fade">
        <support-menu @close="reverseDialog(2)" v-if="dialogs[2].value" @closeMenu="closeMenu"/>
      </transition>
      <Share v-if="$store.state.sharing" @close-dialog="closeDialog"/>
      <login v-if="$store.state.loginDialog" />
      <register v-if="$store.state.registerDialog" />
      <div v-if="$store.state.editProfile">
        <edit-profile />
      </div>
    </v-main>
  </v-app>
</template>

<script>

import SupportMenu from './components/Menus/SupportMenu'
import $ from 'jquery'
import utils from './shared/utils'
import Share from './components/Menus/ShareSocialMedia'
import Sidebar from './components/sidebar/Sidebar'
import login from './components/dialogs/login/login'
import register from './components/dialogs/register/register'
import WelcomeMenu from './components/Menus/WelcomeMenu'
import EditProfile from './components/dialogs/edit-user/EditProfile'
export default {
  name: 'App',
  components: { SupportMenu, Share, Sidebar, login, register, WelcomeMenu, EditProfile },
  data: () => ({
    reverseDialog: utils.changeDialogStatus,
    dialogs: utils.dialogs

  }),
  mounted () {
    this.arabic()
    this.$watch(() => {
      return this.$store.state.sharing
    }, (val) => {
      if (!val) {
        this.$store.state.sharingLink = ''
        this.$store.state.sharedMessage = ''
      }
    })
    setTimeout(() => {
      this.$notify({
        group: 'foo',
        title: 'Important message',
        text: 'Hello user! This is a notification!'
      })
    }, 2000)
    window.addEventListener('resize', () => {
      this.$store.state.window = window.innerWidth
      if (window.innerWidth > 1100) {
        this.$store.state.sidebar = false
      }
    })
    utils.checkLang()
    setTimeout(() => {
      this.$lang === 'ar' ? $('.menu-title').css('font-family', 'Mtn-arabic-bold') : $('.menu-title').css('font-family', 'Mtn-bold')
      this.$lang === 'ar' ? $('.customNotification .vue-notification.error').css('font-family', 'Mtn-arabic-regular') : $('.customNotification .vue-notification.error').css('font-family', 'Mtn-regular')
      this.$lang === 'ar' ? $('.customNotification .vue-notification.success').css('font-family', 'Mtn-arabic-regular') : $('.customNotification .vue-notification.success').css('font-family', 'Mtn-regular')
      this.$lang === 'ar' ? $('.needHelp').css('font-family', 'Mtn-arabic-bold') : $('.needHelp').css('font-family', 'Mtn-bold')
      this.$lang === 'ar' ? $('.needHelp').css('left', 'calc(1.5vw + 0.5rem)') && $('.blur-help').css('left', 'calc(3vw + 0.5rem)') : $('.needHelp').css('right', 'calc(1.5vw + 0.5rem)') && $('.black-blur.blur-help').css('right', 'calc(3vw + 0.5rem)')
      this.$lang === 'ar' ? $('span .bold-title').css('font-family', 'Mtn-arabic-bold !important') : $('span .bold-title').css('font-family', 'Mtn-bold !important')
    })
  },
  methods: {
    closeDialog () {
      this.$store.state.sharing = false
    },
    closeMenu () {
      this.dialogs[2].value = false
    },
    arabic () {
      $('#app').css('font-family', 'Mtn-arabic-regular')
    }
  }
}
</script>
<style lang="scss">
@import "src/assets/sass/main";

/* fonts */
@font-face {
  font-family: Mtn-regular;
  src: url("./assets/fonts/MTNBrighterSansRegular.ttf");
}
@font-face {
  font-family: Mtn-bold;
  src: url("./assets/fonts/MTNBrighterSansBold.ttf");
}
@font-face {
  font-family: Mtn-bold-italic;
  src: url("./assets/fonts/MTNBrighterSansBoldItalic.ttf");
}
@font-face {
  font-family: Mtn-arabic-regular;
  src: url("./assets/fonts/MTNBrighterSansArabic-Regular.ttf");
}
@font-face {
  font-family: Mtn-arabic-bold;
  src: url("./assets/fonts/MTNBrighterSansArabic-Bold.ttf");
}
@font-face {
  src: url("./assets/fonts/MTNBrighterSans-Medium.ttf");
  font-family: Mtn-medium;
}
@font-face {
  src: url("./assets/fonts/MTNBrighterSansArabic-Medium.ttf");
  font-family: Mtn-arabic-medium;
}
.regular {
  font-family: Mtn-regular!important;
}
.bold {
  font-family: Mtn-bold!important;
}
.bold-italic {
  font-family: Mtn-bold-italic!important;
}
.regular-en{
  font-family: Mtn-regular !important;
}
.regular-ar{
  font-family: Mtn-arabic-regular !important;
}
.bold-en{
  font-family: Mtn-bold !important;
}
.bold-ar{
  font-family: Mtn-arabic-bold !important;
}
.bold-italic-en{
  font-family: Mtn-bold-italic !important;
}
.bold-italic-ar {
  font-family: Mtn-arabic-bold !important;
  font-style: italic !important;
}
.regular-italic-en{
  font-family: Mtn-regular !important;
  font-style: italic !important;
}
.regular-italic-ar{
  font-family: Mtn-arabic-regular !important;
  font-style: italic !important;
}
.medium-en{
  font-family: Mtn-medium !important;
}
.medium-ar{
  font-family: Mtn-arabic-medium !important;
}
.medium-italic-en{
  font-family: Mtn-medium !important;
  font-style: italic;
}
.medium-italic-ar{
  font-family: Mtn-arabic-medium !important;
  font-style: italic;
}
.pointer{
  cursor: pointer;
}
/* validation error */
.error-message {
  color: #FF4E3E;
  font-size: 11px;
  font-family: Mtn-regular;
  float: left;
  text-align: left;
}
.red-border {
border: 1px #FF4E3E solid!important;
}

/*!* Notifications *!*/
.vue-notification-group{
  z-index: 1000000000000 !important;
}
.triangle{
  display: block;
  height: 18px;
  width: 20px;
  position: fixed;
  //top: 98px;
  top: 92.4px;
  /*right: calc(4vw + 28px);*/
  z-index:  499001;
  clip-path: polygon(0% 0%, 100% 100%, 0% 100%);
  transform: rotate(138deg);
  border-radius: 0 0 0 5px;
  background: rgb(242, 242, 242, 0.9);
  backdrop-filter: blur(10px);
}
.right-side{
  right: calc(4vw + 22px);
}
.left-side{
  left: calc(4vw + 22px);
}
/*.vue-notification {*/
/*  margin: 10px 5px 5px!important;*/
/*  padding: 10px;*/
/*  border-radius: 5px;*/
/*  font-size: 12px;*/
/*//margin-top: 5px !important;*/
/*&.error {*/
/*   text-align: center;*/
/* //background: #f54b4b !important;*/
/* //border-left-color: #f54b4b !important;*/
/*   background: #FF4E3E!important;*/
/*   border-left-color: transparent!important;*/
/* }*/
/*&.success {*/
/*   text-align: center;*/
/* //background: #4caf50 !important;*/
/* //border-left-color: #4caf50 !important;*/
/*   background: #5CE19F !important;*/
/*   border-left-color: transparent !important;*/
/* }*/
/*&.info {*/
/*   text-align: center;*/
/* //background: #4caf50 !important;*/
/* //border-left-color: #4caf50 !important;*/
/*   background: #5CE19F !important;*/
/*   border-left-color: transparent !important;*/
/* }*/
/*}*/

/* button loader */
.spinner-border {
  width: 24px!important;
  height: 24px!important;
  color: $--blue;
  opacity: 0.4;
}

/* html && app */
html {
  overflow-y: auto!important;
}
//.v-application {
//  height: 0!important;
//}
*:focus {
  outline: none;
}
#app {
  //font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: $--black;
  font-family: Mtn-regular;
  font-size: 14px;
  background-size: cover!important;
  overflow: hidden;
  cursor: default;
}
v-app {
  //font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: $--blue;
  font-family: Mtn-regular;
  font-size: 14px;
  background-size: cover!important;
  overflow: hidden;
}

/*scroll-handle*/
*::-webkit-scrollbar {
  width: 9px!important;
  height: 9px!important;
  background: rgba(255, 255, 255, 0.5)!important;
  border-radius: 20px!important;
  scroll-padding: 20px!important;
}
*::-webkit-scrollbar-thumb {
  background: rgba(0, 0,0, 0.15)!important;
  border-radius: 20px!important;
  opacity: 0.7!important;
}
</style>
<style>
  .customNotification .vue-notification.success, .customNotification .vue-notification.error  {
    margin: 10px 5px 5px !important;
    padding: 10px;
    border-radius: 5px;
    font-size: 12px;
    border-left-color: transparent!important;
    text-align: center !important;
    font-weight: bold;
    font-family: Mtn-regular;
  }
  .customNotification .vue-notification.success {
    background: #5CE19F!important;
  }
  .customNotification .vue-notification.error {
    background:#E50019!important;
  }
</style>
